<style lang="scss" src="./style.scss" scoped></style>
<script src="./script"></script>
<template>
    <breadcrumb :links="breadcrumb"></breadcrumb>
    <div class="page">
        <div class="page-header p-3">
            <h1>Hướng dẫn nhúng CPD vào trang đối tác</h1>
        </div>
      <div class="page-body p-3">
        <div class="alert alert-warning text-bold"><b>Chỉ sử dụng 1 trong 2 cách bên dưới</b></div>
        <div class="mb-5">
          <h5>Cách 1: Sử dụng thẻ <b class="text-primary">iframe</b></h5>
          <i class="text-danger">Cách này thường sử dụng cho các site bên ngoài, không thuộc quản lí của công ty mình.</i>
          <div class="mt-2">
            <div>1. Tại màn hình quản lí CPD, nhấn button lấy mã <i class="fa-solid fa-code text-success"></i> <a href="javascript: void(0)" class="view" @click="openImage('Nhấn lấy mã embed' ,['/images/get_code.png'])"><i class='bx bx-image-alt' ></i> Xem ảnh</a></div>
            <div>2. Nhấn qua tab IFRAME <div class="btn-group btn-group-sm"><button style="padding: 0 0.5rem;" class="btn btn-sm btn-secondary">script</button><button style="padding: 0 0.5rem;" class="btn btn-sm btn-success">iframe</button></div></div>
            <div>3. Tùy vào vị trí hiển thị trên site đối tác, copy <i class="text-success">[iframe vị trí]</i> phù hợp <a href="javascript: void(0)" class="view" @click="openImage('Nhúng iframe vào vị trí' ,['/images/iframe_pos.png'])"><i class='bx bx-image-alt' ></i> Xem ảnh</a></div>
            <div class="mb-2">4. Gửi mã iframe cho đối tác, dán vào vị trí muốn hiển thị CPD <a href="javascript: void(0)" class="view" @click="openImage('Nhúng iframe vào site đối tác' ,['/images/iframe_wp.png'])"><i class='bx bx-image-alt' ></i> Xem ảnh</a></div>
            <div class="note">
              <i><b>Ghi chú:</b> Kích thước của iframe sẽ phụ thuộc vào kích thước của thẻ container, trường hợp bên site đối tác không có thẻ container để CPD được hiển thị chuẩn thì thay thế [width="100%" heigh="100%"] trên thẻ iframe bằng width &amp; height của vị trí đặt quảng cáo (đối tác cung cấp)</i>
            </div>
          </div>
        </div>

        <div>
          <h5>Cách 2: Nhúng thẻ <b class="text-primary">script</b></h5>
          <i class="text-danger">Ở các site nội bộ ưu tiên sử dụng cách này.</i>
          <div class="mt-2">
            <div>1. Tại màn hình quản lí CPD, nhấn button lấy mã <i class="fa-solid fa-code text-success"></i> <a href="javascript: void(0)" class="view" @click="openImage('Nhấn lấy mã embed' ,['/images/get_code.png'])"><i class='bx bx-image-alt' ></i> Xem ảnh</a></div>
            <div>2. Nhấn qua tab SCRIPT <div class="btn-group btn-group-sm"><button style="padding: 0 0.5rem;" class="btn btn-sm btn-success">script</button><button style="padding: 0 0.5rem;" class="btn btn-sm btn-secondary">iframe</button></div></div>
            <div>3. Copy & dán mã <i class="text-success">[Thẻ script]</i> vào footer của site hiển thị quảng cáo <a href="javascript: void(0)" class="view" @click="openImage('Nhúng mã script vào footer' ,['/images/script_footer.png', '/images/script_footer_wp.png'])"><i class='bx bx-image-alt' ></i> Xem ảnh</a></div>
            <div>4. Trên mã có 1 hoặc nhiều thẻ vị trí, copy & dán mã của <i class="text-warning">[Thẻ vị trí]</i> tương ứng vào vị trí muốn hiển thị trên site đối tác. <a href="javascript: void(0)" class="view" @click="openImage('Nhúng mã vị trí vào nơi hiển thị' ,['/images/script_pos.png', '/images/script_pos_wp.png'])"><i class='bx bx-image-alt' ></i> Xem ảnh</a></div>
          </div>
        </div>

        <doc-menu class="mt-5"></doc-menu>
      </div>
    </div>

    <b-modal ref="img" class="modal-xl" @close="closeImage()">
      <div class="modal-header">
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <button type="button" class="btn btn-cls" data-bs-dismiss="modal"><i class="fa fa-remove"></i></button>
      </div>
      <div class="modal-body" v-if="modalTitle">
        <div class="mb-3" v-for="(src, i) in modalImages" :key="i">
          <img :src="src" style="width: 100%;">
        </div>
      </div>
    </b-modal>
  </template>